module.exports = __webpack_public_path__ + "static/media/figure20.a9d62d9a.png";